import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getServiceById } from "../../app/api";
import { useNavigate, useParams } from "react-router-dom";
import ServiceSlider from "./service-slider";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export enum NewsType {

  image = "Зураг",
  video = "Бичлэг",
  reminder = "Санамж",
  notice = "Зарлал",

}


export interface INews {
  title: string;
  subtitle: string;
  content: string;
  thumb: string;
  images: [string];
  type: NewsType;
  videoUrl: string;
  createAdmin: string;
  updateAdmin: string;
  status: boolean;
}

export default function ServiceDetail() {

  const [news, setNews] = useState<INews>({} as INews);
  const [images, setImages] = useState<any>([]);

  const params = useParams();

  useEffect(() => {
    try {
      getServiceById(params.id).then((res) => {
        setNews(res.data);
        if (res.data.images && res.data.images.length > 0) {
          setImages(res.data.images.map((image: any) => {
            return {
              original: image,
              thumbnail: image,
            };
          }));
        }
      });
    } catch(err) {
    }
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  }, [params.id]);

  return (
    <>
      {/* Dark hero */}
      <div className="relative overflow-hidden bg-[#0a1628] -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/15 blur-[100px]" />
        </div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative pt-40 pb-12 sm:pt-48 sm:pb-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight">
              {news.title}
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Image with glow */}
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-warm-500/20 via-transparent to-primary-500/20 rounded-2xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden shadow-lg border border-neutral-200 group">
                {news.videoUrl ? (
                  <div className="relative w-full aspect-video bg-black">
                    <iframe
                      src={`https://www.youtube.com/embed/${news.videoUrl.split("v=")[1].split("&")[0]}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Video"
                      className="absolute inset-0 w-full h-full"
                    />
                  </div>
                ) : (
                  <img
                    className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                    src={news.thumb}
                    alt={news.title}
                  />
                )}
              </div>
            </div>

            {/* Text content */}
            <div>
              <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
                <div className="text-base sm:text-lg leading-7 text-neutral-600">
                  <HTMLTextView htmlContent={news.content} />
                </div>
              </div>
            </div>

            {/* Image gallery */}
            {news.images && news.images.length > 0 && (
              <div className="lg:col-span-2">
                <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
                  <h2 className="section-header text-2xl sm:text-3xl mb-6">
                    <span className="gradient-text">Зургийн цомог</span>
                  </h2>
                  <div className="w-full rounded-2xl overflow-hidden">
                    <ImageGallery items={images} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Related services */}
      <div className="bg-neutral-50 py-16 sm:py-20">
        <ServiceSlider />
      </div>
    </>
  );
}
